import { useEffect, useState } from 'react';
import { Card, Grid, Text } from '@mantine/core';
import { useSelector } from 'react-redux';
import useFetch from '../../../../helpers/useFetch';
import ErrorMessage from '../../../ErrorMessage';
import FileUpload from '../../../FileUpload';

const SettingsTabGCS = () => {
  // commenting out logo related elements, as we will not be generating them currently
  // not removing them because we will use them in another tool
  const [loadError, setLoadError] = useState();
  const [userError, setUserError] = useState();
  const [googleServiceAccount, setGoogleAccount] = useState();
  const { domain } = useSelector((state) => state.domain);
  const fetch = useFetch();

  useEffect(() => {
    fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/googleServiceAccounts`)
      .then(({ googleServiceAccount }) => setGoogleAccount(googleServiceAccount))
      .catch(setLoadError);
  }, [domain.accountId, domain.id, fetch]);

  const save = (file) => {
    const reader = new FileReader();

    // Define what happens when the file is loaded
    reader.onload = function (e) {
      const parsed = JSON.parse(e.target.result); // The file content as a string

      fetch(`/api/admin/accounts/${domain.accountId}/domains/${domain.id}/googleServiceAccounts`, {
        method: 'POST',
        body: JSON.stringify({
          projectId: parsed.project_id,
          privateKeyId: parsed.private_key_id,
          privateKey: parsed.private_key,
          clientEmail: parsed.client_email,
          clientId: parsed.client_id,
          authUri: parsed.auth_uri,
          tokenUri: parsed.token_uri,
          authProviderX509CertUrl: parsed.auth_provider_x509_cert_url,
          clientX509CertUrl: parsed.client_x509_cert_url,
          universeDomain: parsed.universe_domain,
        }),
      })
        .then(({ googleServiceAccount }) => {
          setGoogleAccount(googleServiceAccount);
        })
        .catch(setUserError);
    };

    reader.readAsText(file);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  return (
    <Card withBorder>
      <Card.Section p="md">
        <Grid mb="md">
          <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'flex-start', paddingTop: 8 }}>
            <label>Google Service Account Credentials</label>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <FileUpload label={googleServiceAccount?.clientEmail} onFileSet={([file]) => save(file)} />
            <Text size="xs" c="dimmed" mt="xs">
              Please provide the Google service account credentials .json file.
              <br />
              Your developers can generate this from your Google console by going into <strong>
                Project settings
              </strong>{' '}
              -&gt; <strong>Service accounts</strong>, and clicking on <strong>Generate new private key</strong>
            </Text>
          </Grid.Col>
        </Grid>
      </Card.Section>
      <ErrorMessage message={userError?.message} />
    </Card>
  );
};

export default SettingsTabGCS;
